import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=60e271ee&scoped=true&"
import script from "./AppColorPicker.vue?vue&type=script&lang=js&"
export * from "./AppColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=60e271ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e271ee",
  null
  
)

export default component.exports